var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "chat-badge d-inline-flex align-center rounded-pill px-3 py-1",
      class: _vm.badgeClass
    },
    [
      _vm.icon
        ? _c("icon-svg", {
            staticClass: "mr-1",
            attrs: {
              name: _vm.icon,
              size: "12",
              color:
                _vm.variant === "note"
                  ? "#F57F17"
                  : _vm.variant === "system"
                  ? "#616161"
                  : "#54656F"
            }
          })
        : _vm._e(),
      _c("span", { staticClass: "az-text-small font-medium" }, [
        _vm._v(_vm._s(_vm.text))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }